import { Link } from 'react-router-dom';
import Icon from '../components/ui/Icon.jsx';
import './NotFoundPage.css';

function NotFoundPage() {
  return (
    <main className="v3-404">
      <div className="nf-card">
        <div className="nf-visual">
          <div className="nf-ring" />
          <div className="nf-dot-bg" />
          <svg viewBox="0 0 200 600" aria-hidden="true">
            <use href="#dart-full" />
          </svg>
        </div>
        <p className="nf-num">ERROR 404</p>
        <h1 className="nf-h1">這一鏢，擲偏了</h1>
        <p className="nf-desc">你想找的頁面不在這裡。可能是連結過期、或剛搬家。下面是幾個你也許感興趣的去處。</p>
        <div className="nf-actions">
          <Link className="btn btn-primary" to="/">回到首頁 <Icon name="arrow" size={14} /></Link>
          <Link className="btn btn-ghost" to="/shop">逛逛商品</Link>
        </div>
      </div>
    </main>
  );
}

export default NotFoundPage;
